// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"8a1d28f9","658":"c3b7f9b3","677":"d9bb7f98","778":"a3be8723"}[chunkId] + ".chunk.js";
};